import { render, staticRenderFns } from "./SocialComponent.vue?vue&type=template&id=4ccfbe2a"
import script from "./SocialComponent.vue?vue&type=script&lang=js"
export * from "./SocialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports